import DatabaseModel from './DatabaseModel.js';
import { unwrapDto } from './responseUtils.js';

const RhPuestos = Object.create(DatabaseModel);

RhPuestos.model = 'rh/puestos';
RhPuestos.modelFront = 'puestostrabajo';

// GET /movilidad/rh/puestos[?soloActivos=true]
// → lista de { id, codigo, nombre, activo, numeroFunciones, numeroPersonas, avisos[],
//              creadoPor, fechaCreacion, actualizadoPor, fechaActualizacion }
//
// `numeroPersonas` son las personas DISTINTAS de todas las funciones del puesto, contadas sobre
// `rh_empleado_funcion` (#51): alguien con dos funciones del mismo puesto cuenta una vez.
//
// Los puestos viajan en `list` del ResponseDto, así que unwrapDto devuelve null si no hay
// ninguno: de ahí el `|| []`.
RhPuestos.listar = function(soloActivos) {
    const self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + (soloActivos ? '?soloActivos=true' : ''),
        method: 'GET'
    }, false).then(function(res) {
        return unwrapDto(res) || [];
    });
};

// POST /movilidad/rh/puestos → el puesto creado. Nace activo.
// El código se guarda en mayúsculas y es único en todo el catálogo, también frente a los
// desactivados: el backend rechaza el repetido con su mensaje.
RhPuestos.crear = function(puesto) {
    const self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model,
        method: 'POST',
        data: puesto
    }, false).then(unwrapDto);
};

// PUT /movilidad/rh/puestos/{id} → el puesto editado.
// Sólo cambia el nombre: el código no se edita una vez creado, y mandar otro distinto da error.
RhPuestos.editar = function(id, puesto) {
    const self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/' + encodeURIComponent(id),
        method: 'PUT',
        data: puesto
    }, false).then(unwrapDto);
};

// POST /movilidad/rh/puestos/{id}/estado → desactivar o reactivar.
// Es la única baja que hay: no existe borrado, y las dos acciones quedan en rh_audit.
RhPuestos.cambiarActivo = function(id, activo, motivo) {
    const self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/' + encodeURIComponent(id) + '/estado',
        method: 'POST',
        data: { activo: activo, motivo: motivo }
    }, false).then(unwrapDto);
};

export default RhPuestos;
